import { actions } from "../actions";
// import { hasAccessToken } from "../../helpers/utils";
import { t } from "i18next";

const initialState = {
  isLoggedIn: localStorage.getItem("accessToken"),
  userInfo: localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : {
      // accessToken: "P8zG0tInEvR84jG8iabOmTBOzTuvfCYnv0adGIi1",
      // refreshToken: "atRtGCh8kBqtU2A8V2dH26p1K7cDBvchOx2FjFWA",
      // nationalId: "9392008368",
      // englishName: "MAHMOUD YOUSEF MOUSA IDEIS",
      // arabicName: "محمود يوسف موسى ادعيس",
      // birthDate: "1977-01-14T00:00:00",
    },
  isLoading: false,
  errorMessage: "",
  successMessage: "",
  summaryMessage: "",
  sellingFormDetails: {
    taskId: "",
    donation: false,
    propertyData: {},
    selectedShares: [],
    isTotalShares: false,
    buyersDetails: [],
    clientsDetails: [],
    realtyValue: "",
    buyerSellersMapper: [],
    realtyBelongings: [],
    additionalBelongingsValue: "",
    attachments: {},
    support: false,
    accumilative: [],
    accumilativeTenantContribution: 0,
    tempAttach: {},
    hasDemolishedBuilding: false,
  },
  noError: false,
  proparties: [],
  applicantInfo: {
    citizenInformation: {},
    companyInformation: {},
    foreignInformation: {},
  },
};

function rootReducer(state = initialState, action) {
  if (action.type === actions.UPDATE_USER_INFO) {
    const userInfo = {
      accessToken: action.payload.accessToken,
      refreshToken: action.payload.refreshToken,
      nationalId: action.payload.nationalId,
      englishName: action.payload.englishName,
      arabicName: action.payload.arabicName,
      englishShortName: action.payload.englishShortName,
      arabicShortName: action.payload.arabicShortName,
      birthDate: action.payload.birthDate,
      birthPlace: action.payload.birthPlace,
      carD_NO: action.payload.carD_NO,
      nationality: action.payload.nationality,
      phone: action.payload.phone,
      email: action.payload.email,
      userType: action.payload.userType,
    };

    localStorage.setItem(
      "userInfo",
      JSON.stringify({
        arabicShortName: userInfo.arabicShortName,
        englishShortName: userInfo.englishShortName,
        userType: userInfo.userType,
      })
    );

    return {
      ...state,
      isLoggedIn: true,
      userInfo,
    };
  }
  if (action.type === actions.UPDATE_APPLICANT_INFO) {
    return {
      ...state,
      applicantInfo: { ...action.payload },
    };
  }
  if (action.type === actions.LOGOUT) {
    localStorage.removeItem("userInfo");

    return {
      ...state,
      userInfo: {},
      isLoggedIn: false,
    };
  }
  if (action.type === actions.UPDATE_LOADING) {
    return {
      ...state,
      isLoading: action.payload,
    };
  }
  if (action.type === actions.UPDATE_ACCESS_TOKEN) {
    return {
      ...state,
      userInfo: {
        ...state.userInfo,
        accessToken: action.payload,
      },
    };
  }
  if (action.type === actions.SHOW_ERROR) {
    return {
      ...state,
      errorMessage:
        action.payload === "GeneralError"
          ? t("errors.pleaseTryAgain")
          : action.payload,
    };
  }
  if (action.type === actions.UPDATE_SELLING_FORM_OBJECT) {
    return {
      ...state,
      sellingFormDetails: {
        tempAttach: state.sellingFormDetails.tempAttach,
        ...action.payload,
      },
    };
  }
  if (action.type === actions.START_NEW_SELLING_PROCESS) {
    return {
      ...state,
      sellingFormDetails: {
        applicantInfo: state.applicantInfo,
        taskId: "",
        processInstanceId: "",
        donation: false,
        propertyData: {},
        selectedShares: [],
        isTotalShares: false,
        buyersDetails: [],
        realtyValue: "",
        buyerSellersMapper: [],
        realtyBelongings: [],
        additionalBelongingsValue: "",
        attachments: {},
        support: false,
        accumilative: [],
        sponsorType: "self",
        mortgageInfo: {
          isTransferableMortgage: true,
          isRented: true,
        },
        creditorDetails: [],
        deptorsDetails: [],
        tempAttach: {},
      },
    };
  }
  if (action.type === actions.START_NEW_MORTGAGE_PROCESS) {
    return {
      ...state,
      sellingFormDetails: {
        taskId: "",
        processInstanceId: "",
        propertyData: {},
        selectedShares: [],
        deptorsDetails: [],
        realtyValue: "",
        creditorDetails: [],
        realtyBelongings: [],
        attachments: {},
        sponsorType: "self",
        mortgageInfo: {
          isTransferableMortgage: true,
          isRented: true,
        },
        tempAttach: {},
      },
    };
  }
  if (action.type === actions.SHOW_SUCCESS) {
    return {
      ...state,
      successMessage: action.payload,
      summaryMessage: action.summaryMessage,
    };
  }
  if (action.type === actions.LOGIN) {
    return {
      ...state,
      isLoggedIn: true,
    };
  }
  if (action.type === actions.NO_ERROR) {
    return {
      ...state,
      noError: action.payload,
    };
  }

  return state;
}

export default rootReducer;
